module.exports = __webpack_public_path__ + "img/slide-18-3.a35e8b20.jpg";